import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import Contact from "./Contact";

const ContactWrapper = () => {
  const GOOGLE_RECAPTCHA_KEY = '6LfE7S4sAAAAAMNAnER8Rv5w0psYzN9A-uDEmuVS';

  if (!GOOGLE_RECAPTCHA_KEY) {
    console.warn("Google reCAPTCHA key is not configured");
    return <Contact />;
  }

  return (
    <GoogleReCaptchaProvider 
      reCaptchaKey={GOOGLE_RECAPTCHA_KEY}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "body",
      }}
    >
      <Contact />
    </GoogleReCaptchaProvider>
  );
};

export default ContactWrapper;

